<template>
  <v-card
    class="card py-5 d-flex align-center"
    flat
    tile
    color="transparent"
    :to="`/lector/${lector.id}`"
  >
    <div class="card__img mr-5">
      <v-img
        width="72"
        height="72"
        :src="require(`@/assets/img/lectures2025/${lector.img}`)"
        position="top center"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="#FFA903" />
          </v-row>
        </template>
      </v-img>
    </div>
    <div class="card__name">
      <h3>{{ lector.firstName }}<br />{{ lector.lastName }}</h3>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "LectorCardSmall",
  props: {
    lector: {
      type: Object,
      require: true
    }
  }
};
</script>

<style lang="sass" scoped>
.card
  border-bottom: 1px solid rgba(#A0A0AE, .1) !important
  &__name
    h3
      font-weight: 700
      font-size: 24px !important
      line-height: 30px
</style>
